import { DocumentTypeWithVirtual, ProcessSpecificationDTO, RelationshipV2 } from 'support/types';
import { BasePopup } from 'components/Display/BasePopup/BasePopup';

import { Extractor } from './components/Extractor/Extractor';
import { OcrResult } from './types';

type DocumentExtractorProps = {
  senderProcessSpecification: ProcessSpecificationDTO;
  targetRelationship: RelationshipV2;
  onApplyOcrExtraction: (result: OcrResult) => void;
  setOpen: (open: boolean) => void;
  open: boolean;
  sourceDocumentId: string | undefined;
  virtualDocumentType: DocumentTypeWithVirtual;
};

export const DocumentExtractor = ({
  open,
  setOpen,
  senderProcessSpecification,
  targetRelationship,
  onApplyOcrExtraction,
  sourceDocumentId,
  virtualDocumentType,
}: DocumentExtractorProps) => {
  return (
    <BasePopup setOpen={setOpen} open={open} width="xl" shouldGrowIndefinitely>
      <Extractor
        senderProcessSpecification={senderProcessSpecification}
        targetRelationship={targetRelationship}
        onApplyOcrExtraction={onApplyOcrExtraction}
        setOpen={setOpen}
        sourceDocumentId={sourceDocumentId}
        virtualDocumentType={virtualDocumentType}
      />
    </BasePopup>
  );
};
